import { Work } from '@public';
import { WorkItemType } from '@types';
import { formatNumber } from '@utils';

import styles from './workDetails.module.scss';

export interface WorkDetailsProp {
	work: WorkItemType;
}

export const WorkDetails = ({ work }: WorkDetailsProp) => {
	const {
		reference,
		type,
		status,
		hydraulicType,
		artesianCondition,
		depth,
		localBoreName,
		pumpOrHeadwork,
		gwbRegistrationNo,
		pumpType,
		stroke,
		bore,
		outlet,
		inlet,
		dutyDischarge,
		dutyHead,
		motorType,
	} = work;

	const createDetailSection = () => {
		const createDetails = (header: string, content: string | number) => {
			return (
				<>
					<h6>{header}</h6>
					<p>{content}</p>
				</>
			);
		};
		const renderItem = [
			{ header: 'Status', content: status },
			{ header: 'Hydraulic type', content: hydraulicType },
			{ header: 'Artesian condition', content: artesianCondition },
			{ header: 'Depth', content: depth ? formatNumber(depth, 4) : depth },
			{ header: 'Local bore name', content: localBoreName },
			{ header: 'Pump or headworks', content: pumpOrHeadwork },
			{ header: 'GWDB registration no.', content: gwbRegistrationNo },
			{ header: 'Pump type', content: pumpType },
			{ header: 'Stroke', content: stroke },
			{ header: 'Bore', content: bore },
			{ header: 'Outlet', content: outlet },
			{ header: 'Inlet', content: inlet },
			{ header: 'Duty discharge', content: dutyDischarge },
			{ header: 'Duty head', content: dutyHead },
			{ header: 'Motor type', content: motorType },
		];
		return (
			<div className={styles['detail-container']}>
				{renderItem.map(({ header, content }, id) => {
					if (!content) return null;
					return (
						<div key={id} className={styles['detail-item']}>
							{createDetails(header, content)}
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<div className={styles.container} data-testid="workDetails">
			<div className={styles.title}>
				<h2>Work details</h2>
				<Work customStyles={styles['title-icon']} />
			</div>
			<div className={styles['border-title']} />
			<div className={styles.brief}>
				<div className={styles.name}>
					<h3>Reference: {reference}</h3>
				</div>
				<p className={styles.ref}>Type: {type}</p>
			</div>
			<div className={styles.tabs}>
				<div className={styles.details}>
					<h5>Details</h5>
				</div>
				<div className={styles['border-tab']} />
			</div>
			<div className={styles['sublist-container']}>{createDetailSection()}</div>
		</div>
	);
};
